if (!customElements.get('vosper-swiss-home')) {
  customElements.define('vosper-swiss-home', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-watch-ready')) return;
      this.setAttribute('data-watch-ready', 'true');
      const enquiry = this.querySelector('[data-watch-enquiry]');
      const form = enquiry?.querySelector('form');
      const storageKey = form ? 'vosper-watch-enquiry:' + form.id : '';
      const setContext = (context) => {
        if (!form || !context || typeof context.name !== 'string') return;
        const reference = typeof context.reference === 'string' ? context.reference : '';
        const url = typeof context.url === 'string' ? context.url : '';
        enquiry.querySelector('[data-enquiry-watch-name]').textContent = context.name;
        enquiry.querySelector('[data-enquiry-watch-reference]').textContent = reference;
        enquiry.querySelector('[data-enquiry-reference-row]').hidden = !reference;
        form.querySelector('[data-enquiry-watch-field]').value = context.name;
        form.querySelector('[data-enquiry-reference-field]').value = reference;
        form.querySelector('[data-enquiry-url-field]').value = url;
      };
      const showDialog = (dialog) => {
        if (dialog && !dialog.open) {
          dialog.showModal();
          dialog.scrollTop = 0;
        }
      };
      if (form) {
        form.addEventListener('input', (event) => {
          if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
        });
        form.addEventListener('submit', (event) => {
          form.querySelectorAll('[required]').forEach((field) => {
            field.value = field.value.trim();
            field.setCustomValidity(field.value ? '' : enquiry.dataset.requiredMessage);
          });
          const mobile = form.querySelector('[data-enquiry-mobile]');
          const digits = mobile.value.replace(/\D/g, '');
          if (mobile.value && (!/^\+?[\d\s().-]+$/.test(mobile.value) || digits.length < 8 || digits.length > 15)) {
            mobile.setCustomValidity(enquiry.dataset.mobileMessage);
          }
          const watch = form.querySelector('[data-enquiry-watch-field]').value;
          const contextError = enquiry.querySelector('[data-enquiry-context-error]');
          contextError.hidden = Boolean(watch);
          if (!watch || !form.reportValidity()) {
            event.preventDefault();
            if (!watch) contextError.focus();
            return;
          }
          form.querySelector('[data-enquiry-full-name]').value = form.querySelector('[data-enquiry-first-name]').value + ' ' + form.querySelector('[data-enquiry-last-name]').value;
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({
              name: watch,
              reference: form.querySelector('[data-enquiry-reference-field]').value,
              url: form.querySelector('[data-enquiry-url-field]').value
            }));
          } catch {}
        });
        const result = form.querySelector('[data-enquiry-result]').dataset.enquiryResult;
        if (result) {
          try {
            setContext(JSON.parse(sessionStorage.getItem(storageKey) || 'null'));
            if (result === 'success') sessionStorage.removeItem(storageKey);
          } catch {}
          if (!form.querySelector('[data-enquiry-watch-field]').value) {
            enquiry.querySelector('.swiss-enquiry__watch').hidden = true;
          }
          showDialog(enquiry);
          enquiry.querySelector(result === 'success' ? '[data-enquiry-success]' : '[data-enquiry-errors]').focus();
        }
      }
      this.addEventListener('click', (event) => {
        const enquiryOpener = event.target.closest('[data-watch-enquire]');
        if (enquiryOpener && enquiry && form) {
          setContext({
            name: enquiryOpener.dataset.watchName,
            reference: enquiryOpener.dataset.watchReference,
            url: enquiryOpener.dataset.watchUrl
          });
          enquiry.querySelector('.swiss-enquiry__watch').hidden = false;
          enquiry.querySelector('[data-enquiry-success]').hidden = true;
          enquiry.querySelector('[data-enquiry-errors]').hidden = true;
          enquiry.querySelector('[data-enquiry-context-error]').hidden = true;
          enquiry.querySelector('[data-enquiry-fields]').hidden = false;
          showDialog(enquiry);
          return;
        }
        const opener = event.target.closest('[data-watch-open]');
        if (opener) {
          showDialog(this.querySelector('[id="' + opener.dataset.watchOpen + '"]'));
          return;
        }
        const close = event.target.closest('[data-watch-close]');
        if (close) close.closest('dialog').close();
        const thumbnail = event.target.closest('[data-watch-thumbnail]');
        if (thumbnail) {
          const dialog = thumbnail.closest('dialog');
          dialog.querySelectorAll('[data-watch-photo]').forEach((photo) => { photo.hidden = photo.dataset.watchPhoto !== thumbnail.dataset.watchThumbnail; });
          dialog.querySelectorAll('[data-watch-thumbnail]').forEach((button) => { button.setAttribute('aria-pressed', String(button === thumbnail)); });
        }
        if (event.target instanceof HTMLDialogElement) {
          const bounds = event.target.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
        }
      });
    }
  });
}

